import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
export default function MapaLeaf({ registro,   }) {
  const mapRef = useRef()
  //const params = useParams()

  const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  const [listPoligono, setListPoligono] = useState([])

  useEffect(()=>{         
 
   
   mapRef.current =  leaflet.map('map2').setView([registro.Lat, registro.Lon], 14);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    const greenIcon = nvoIconLeaflet('/marker-icon-2x-green.png') 
    if (registro.length!==0 ) {
      
      
      let marker = leaflet.marker([registro.Lat, registro.Lon], {icon:greenIcon});    
      //const cadena=`${registro.tipo}`          
      //marker.bindPopup(cadena).openPopup();
      //marker.addTo(mapRef.current).on('click', mostrar);
      marker.addTo(mapRef.current)
    }
    
    return () => {
      mapRef.current = null
      
    }

  },[]) 

  const nvoIconLeaflet=(iconUrl, iconAncho)=>{
    const nvo=new leaflet.Icon({
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, 41],
      iconAnchor: [iconAncho??12, 41],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, 41]
    });
    return nvo
  }

  const mostrar=(e)=>{
    //console.log(e);    
  }
 
  return (  
    <div id="map2" ref={mapRef} style={{height:"100%",width:"100%" }}/>  
  );
}